import * as React from 'react'

import styles from './index.module.scss'

interface Props {
  title: string
}

const Container = ({ title, children }: React.PropsWithChildren<Props>) => {
  return (
    <div className={styles.panel}>
      <div className={styles.title}>{title}</div>
      <div>{children}</div>
    </div>
  )
}

export default Container
